import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const AbonnementsListItem = (props: any) => {
  const currentUrl: any = new URL(window.location.href);
  const searchParams: any = currentUrl.searchParams;

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        multipleCheckins={true}
        abonnement={props.abonnement}
        dispatch={props.dispatch}
        app_user_role={props.app_user_role}
        setId={true}
        setFilter={props.setFilter}
        filter={props.filter}
        setNKey={props.setNKey}
        sort={props.sort}
        setSort={props.setSort}
      />
    </>
  );
};

export default AbonnementsListItem;
